export const initialState = {
    browsingMode: '',
    origin: 'home',
    filters: {},
    filtersMetadata: {
        filters_applied_price: false,
        filters_applied_map: false,
        filters_applied_specific: 0
    },
    selectFrom: '',
    landingURL: '',
    autosPageName: ''
};

function countSpecificFilters(filters) {
    let specific = 0;

    for (const prop in filters) {
        if (prop !== 'price' && prop !== 'category') {
            if (Array.isArray(filters[prop])) {
                specific += filters[prop].length;
            }
            else {
                specific += 1;
            }
        }
    }

    return specific;
}

const setTrackingKey = (key, state, data) => {
    return (state[key] === data) ? state : {
        ...state,
        [key]: data
    };
};

export default (state = initialState, { type, data }) => {
    switch (type) {
        case 'LOCATION_CHANGE':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    location: data
                },
                filtersMetadata: {
                    ...state.filtersMetadata,
                    filters_applied_map: true
                }
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                filters: initialState.filters,
                filtersMetadata: initialState.filtersMetadata
            };
        case 'FILTERS_SET':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...data
                },
                filtersMetadata: {
                    ...state.filtersMetadata,
                    filters_applied_price: !!data.price,
                    filters_applied_specific: countSpecificFilters(data)
                }
            };
        case 'ORIGIN_SET':
            return setTrackingKey('origin', state, data);
        case 'BROWSING_MODE_SET':
            return setTrackingKey('browsingMode', state, data);
        case 'CURR_BUNDLE_RESULTSET_SET':
            return setTrackingKey('currBundleResultsetType', state, data);
        case 'FROM_BUNDLE_RESULTSET_SET':
            return setTrackingKey('fromBundleResultsetType', state, data);
        case 'SELECT_FROM_SET': {
            return {
                ...state,
                selectFrom: data
            };
        }
        case 'FLOW_STEP_SET':
            return setTrackingKey('flowStep', state, data);
        case 'FILTER_INTERACTION_SET': {
            return {
                ...state,
                filterInteraction: data
            };
        }
        case 'SET_AUTOS_PAGE_NAME': {
            return setTrackingKey('autosPageName', state, data);
        }
        case 'LANDING_URL_SEARCH_SET':
            return setTrackingKey('landingURLSearch', state, data);
        default:
            return state;
    }
};
